if (!customElements.get('advantages-slider')) {
  class AdvantagesSlider extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.initializeSlider();
    }

    initializeSlider() {
      if (typeof window.FoxTheme === 'undefined' || typeof window.FoxTheme.Carousel === 'undefined')  return;
      
      const sliderOptions = {
        slidesPerView: 1.75,
        spaceBetween: 32,
        slidesOffsetAfter: 20,
        slidesOffsetBefore: 20,
        navigation: {
          nextEl: this.closest('.section').querySelector('.swiper-btn-next'),
          prevEl: this.closest('.section').querySelector('.swiper-btn-prev'),
        },
        pagination: false,
        breakpoints: {
          450: {
            slidesPerView: 2,
            slidesOffsetAfter: 0,
            slidesOffsetBefore: 0,
          },
          768: {
            slidesPerView: 3,
            slidesOffsetAfter: 0,
            slidesOffsetBefore: 0,
          },
          1024: {
            spaceBetween: 50,
            slidesPerView: 4,
            slidesOffsetAfter: 0,
            slidesOffsetBefore: 0,
          }
        },
        loop: false,
        threshold: 2,
        touchRatio: 1,
        touchAngle: 45,
        grabCursor: true,
        allowTouchMove: true,
        simulateTouch: true,
        touchStartPreventDefault: false,
        on: {
          slideChange: () => {
            this.updateNavigationState();
          },
          init: () => {
            this.updateNavigationState();
          }
        }
      };

      this.swiper = new window.FoxTheme.Carousel(this, sliderOptions);
      this.swiper.init();
    }

    updateNavigationState() {
      if (!this.swiper) return;
      
      const prevBtn = this.closest('.section').querySelector('.swiper-btn-prev');
      const nextBtn = this.closest('.section').querySelector('.swiper-btn-next');
      
      if (prevBtn) prevBtn.disabled = this.swiper.isBeginning;
      if (nextBtn) nextBtn.disabled = this.swiper.isEnd;
    }

    disconnectedCallback() {
      if (this.swiper) this.swiper.destroy();
    }
  }

  customElements.define('advantages-slider', AdvantagesSlider);
}
